export const SPECS = {
  SendFullAddressOnExpressButtons: 'specs.stores.SendFullAddressOnExpressButtons',
  SendTrackEventWhenCheckoutLoad: 'specs.stores.SendTrackEventWhenCheckoutLoad',
  shouldChangeToBiCatalogV2: 'specs.stores.shouldChangeToBiCatalogV2'
};
//# sourceMappingURL=SPECS.js.map